import {createContext} from 'react'

export const ReservationContext = createContext({});
